import { Controller } from "@hotwired/stimulus"

// Generic expand/collapse toggle — used by the sellers screen's "Livros (N)"
// row to reveal each seller's linked-books sublist without a page reload.
export default class extends Controller {
  static targets = ["content"]
  static values = { openLabel: String }

  toggle(event) {
    const opening = this.contentTarget.classList.contains("u-hidden")
    this.contentTarget.classList.toggle("u-hidden")
    event.currentTarget.setAttribute("aria-expanded", String(opening))
    event.currentTarget.textContent = opening ? "Ocultar" : this.openLabelValue
  }
}
